import Icon from "@material-ui/icons/Person";
import StudentList from "./StudentList";
import StudentCreate from "./StudentCreate";
import StudentEdit from "./StudentEdit";
import StudentShow from "./StudentShow";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "students",
  create: StudentCreate,
  list: StudentList,
  show: StudentShow,
  edit: StudentEdit,
  icon: Icon,
};
